import * as angular from 'angular';
import { MODULE_NAME } from '../../../config/constants';

angular.module(MODULE_NAME)
    .controller('FeedSupportMainNav', ['$scope', 'AppStateService', function($scope, AppStateService) {
        $scope.accountId = AppStateService.getAccountId();
        $scope.feedSupportTicketsLink = `/app/#/${$scope.accountId}/feedsupport/tickets`;
    }]);
